import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PKCEHelperService {

  constructor() { }

  // GENERATING CODE VERIFIER
  dec2hex(dec: any) {
    return ("0" + dec.toString(16)).substr(-2);
  }
  parseToken(token: string): any {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }
  generateCodeVerifier() {
    var array = new Uint32Array(56 / 2);
    window.crypto.getRandomValues(array);
    return Array.from(array, this.dec2hex).join("");
  }

  sha256(plain: any) {
    // returns promise ArrayBuffer
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return window.crypto.subtle.digest("SHA-256", data);
  }

  base64urlencode(a: any) {
    var str = "";
    var bytes = new Uint8Array(a);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      str += String.fromCharCode(bytes[i]);
    }
    return btoa(str)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  }

  async generateCodeChallengeFromVerifier(v: any) {
    var hashed = await this.sha256(v);
    var base64encoded = this.base64urlencode(hashed);
    return base64encoded;
  }
  public sameRootDomain(host1: string, host2: string): boolean {
    host1 = host1.replace("https://", "");
    host2 = host2.replace("https://", "");

    var index1 = host1.indexOf(":");
    var index2 = host2.indexOf(":");


    if (index1 >= 0) {
      host1 = host1.substring(0, index1 - 1);
    }
    if (index2 >= 0) {
      host2 = host2.substring(0, index2 - 1);
    }

    index1 = host1.indexOf("/");
    index2 = host2.indexOf("/");
    if (index1 >= 0) {
      host1 = host1.substring(0, index1 );
    }
    if (index2 >= 0) {
      host2 = host2.substring(0, index2 );
    }

    var parts1 = host1.split(".");
    var parts2 = host2.split(".");

    for (var j = 1; j < parts1.length; j++) {
      if (parts1[j] != parts2[j])
        return false;
    }
    return true;
  }
}
